<div id="attachmentComp-div">
  <mat-card appearance="outlined" id="attachmentComp-div-marCard">
    <div id="attachmentComp-div-matCardDiv">
      @if (toggleBtn) {
        <mat-slide-toggle
          id="attachmentComp-div-matSlide"
          class="example-margin"
          (toggleChange)="(showAttachment === showAttachment)"
          >Attachment</mat-slide-toggle
        >
      }
    </div>
    @if (showAttachment || showAttachmentMode) {
      <div id="attachmentComp-div-ngIf" style="margin-top: 10px">
        <mat-card-content id="attachmentComp-div-mat-content">
          <mat-chip-listbox id="attachmentComp-div-chip">
            @for (file of editFileNameArray; track file) {
              <mat-chip-option id="attachmentComp-div-mat-chip" class="chipStyle-Normal marR16">
                <a
                  id="attachmentComp-div-a"
                  href="javascript:void();"
                  class="icon x-16 icon-close-mini chipIconRight"
                  aria-label="Remove file"
                  (click)="removeEditParent($event, file.fileID)"
                  (keyup.enter)="removeEditParent($event, file.fileID)"
                  tabindex="0"
                ></a>
                <a
                  id="attachmentComp-div-a1"
                  href="javascript:void();"
                  style="color: black; text-decoration: none"
                  (click)="downloadFile(file.fileID)"
                  (keyup.enter)="downloadFile(file.fileID)"
                  tabindex="0"
                >
                  {{ file.fileName }}
                </a>
              </mat-chip-option>
            }
            @for (file of fileNameArray; track file) {
              <mat-chip-option id="attachmentComp-div-mat-chip2" class="chipStyle-Normal marR16">
                <a
                  id="attachmentComp-div-mtChip-a"
                  href="javascript:void();"
                  class="icon x-16 icon-close-mini chipIconRight"
                  aria-label="Remove file"
                  (click)="removeParent($event, file)"
                  (keyup.enter)="removeParent($event, file)"
                  tabindex="0"
                ></a>
                {{ file }}
              </mat-chip-option>
            }
          </mat-chip-listbox>
        </mat-card-content>
        <hr id="attachmentComp-div-hr" />
        <button
          id="attachmentComp-div-butn"
          mat-flat-button
          class="Icon-Btn"
          (click)="openDialog()"
          (keyup.enter)="openDialog()"
          tabindex="0"
        >
          <img
            id="attachmentComp-div-img"
            class="add_attach"
            src="assets/images/icons/purple_icons/icon-add-dark.png"
            alt="Add attachment"
          />
          <span id="attachmentComp-div-span">{{ lable }}</span>
        </button>
      </div>
    }
  </mat-card>
</div>
